import { Action } from '@ngrx/store'
import { HubtypeQueue } from 'models/hubtype-queue'

export const CASE_QUEUES_GET = '[Shared] Get Case Queues'
export const CASE_QUEUES_RECEIVE = '[Shared] Receive Case Queues'
export const CASE_QUEUES_ERROR = '[Shared] Error Case Queues'

export class CaseQueuesGetAction implements Action {
  readonly type = CASE_QUEUES_GET

  constructor() {}
}

export class CaseQueuesReceiveAction implements Action {
  readonly type = CASE_QUEUES_RECEIVE

  constructor(public payload: HubtypeQueue[]) {}
}

export type Actions = CaseQueuesGetAction | CaseQueuesReceiveAction
